export default __webpack_public_path__ + "static/media/home_download_bg.550d28bc.png";